import { Add as AddIcon, DeleteForever as ClearIcon } from '@mui/icons-material';
import { GlobalButton, TimeInput, CheckboxInput } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import {
  WEEK_DAYS,
  WeekDayKey,
} from '@/pages/Business/pages/PickupCycles/models';
import {
  cycleTimeToDate,
  dateToCycleTime,
} from '@/pages/Business/pages/PickupCycles/utils/format';
import CommerceFilterAutocomplete from '@/pages/Business/pages/PickupCycles/components/CommerceFilterAutocomplete';
import BranchFilterAutocomplete from '@/pages/Business/pages/PickupCycles/components/BranchFilterAutocomplete';
import TagFilterInput from '@/pages/Business/pages/PickupCycles/components/TagFilterInput';

interface PickupCyclesToolbarProps {
  commerceFilter: string;
  branchFilter: string;
  tagFilter: string;
  cycleTimeFilter: string;
  daysFilter: WeekDayKey[];
  hasActiveFilters: boolean;
  onCommerceFilterChange: (commerceId: string) => void;
  onBranchFilterChange: (branchId: string) => void;
  onTagFilterChange: (tag: string) => void;
  onCycleTimeFilterChange: (cycleTime: string) => void;
  onDaysFilterChange: (days: WeekDayKey[]) => void;
  onClearFilter: () => void;
  onNewCycle: () => void;
}

const PickupCyclesToolbar = ({
  commerceFilter,
  branchFilter,
  tagFilter,
  cycleTimeFilter,
  daysFilter,
  hasActiveFilters,
  onCommerceFilterChange,
  onBranchFilterChange,
  onTagFilterChange,
  onCycleTimeFilterChange,
  onDaysFilterChange,
  onClearFilter,
  onNewCycle,
}: PickupCyclesToolbarProps) => {
  const handleDayToggle = (day: WeekDayKey, checked: boolean) => {
    if (checked) {
      onDaysFilterChange([...daysFilter, day]);
      return;
    }
    onDaysFilterChange(daysFilter.filter((current) => current !== day));
  };

  return (
    <div className='w-full p-5 flex flex-col gap-4 bg-white rounded-sm shadow-xl'>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4'>
        <CommerceFilterAutocomplete
          value={commerceFilter}
          onChange={onCommerceFilterChange}
        />
        <BranchFilterAutocomplete
          commerceId={commerceFilter}
          value={branchFilter}
          onChange={onBranchFilterChange}
        />
        <TimeInput
          name='cycleTimeFilter'
          placeholder='Vuelta (hora)'
          value={cycleTimeToDate(cycleTimeFilter)}
          onChange={(date) => onCycleTimeFilterChange(dateToCycleTime(date))}
        />
        <TagFilterInput value={tagFilter} onChange={onTagFilterChange} />
      </div>

      <div className='flex flex-col gap-1'>
        <p className='text-sm font-medium text-gray-700'>Días (multidía)</p>
        <div className='flex flex-wrap gap-x-2 gap-y-0'>
          {WEEK_DAYS.map((day) => (
            <CheckboxInput
              key={day.key}
              label={day.label}
              value={daysFilter.includes(day.key)}
              onChange={(checked) => handleDayToggle(day.key, checked)}
            />
          ))}
        </div>
      </div>

      <div className='flex flex-wrap items-center justify-end gap-3'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={onClearFilter}
          disabled={!hasActiveFilters}
        >
          <ClearIcon color='primary' />
          Limpiar filtros
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={onNewCycle}
        >
          <AddIcon />
          Nuevo retiro
        </GlobalButton>
      </div>
    </div>
  );
};

export default PickupCyclesToolbar;
